module.exports = __webpack_public_path__ + "img/orng_1.3eeb91a0.jpg";